import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=51fb936e&scoped=true"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"
import style0 from "./Ventas.vue?vue&type=style&index=0&id=51fb936e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fb936e",
  null
  
)

export default component.exports